<template>
	<div class="mb-base container-fluid" ref="popupContainer">
		<span>
			<vs-popup
				:active.sync="showConfirmationPopup"
				:title="
					'Êtes-vous sûr de vouloir supprimer ce client ' + delUserName + ' ?'
				"
			>
				<div class="vx-row" style="z-index: 100 !important">
					<div class="vx-col sm:w-1/2">
						<vs-button color="primary" class="mt-2 w-full" @click="accept()"
							>Oui</vs-button
						>
					</div>
					<div class="vx-col sm:w-1/2">
						<vs-button color="primary" class="mt-2 w-full" @click="decline()"
							>Non</vs-button
						>
					</div>
				</div>
			</vs-popup>
		</span>
		<FilterCard
			:refreshKey="1"
			:showRowNum="false"
			:filters="filtersTemplates"
			@filter="handleFilterEmits($event)"
			:actions="actionsTemplates"
			@action="handleActionEmits($event)"
			:onChangeEmit="true"
			@clearAll="resetAllFilter()"
		/>

		<vx-card
			style="
				max-height: 69vh;
				overflow: auto;
				display: flex;
				align-items: stretch;
			"
			id="read"
			@scroll="scroll()"
		>
			<div class="vx-row mt-1">
				<div
					class="vx-col mb-base mx-2"
					v-for="(society, index) in displaySocieties(societies).slice(
						0,
						lastPage
					)"
					:key="index"
					style="height: auto; width: 300px"
				>
					<vx-card style="height: 100%; width: 300px">
						<div class="mb-2" style="height: 150px; width: 264px">
							<img
								:src="displaySocietyImage(society.id)"
								alt="society-img"
								class="responsive card-img-top mx-auto"
								style="
									max-height: 150px;
									max-width: 264px;
									width: auto;
									height: auto;
								"
							/>
						</div>
						<h5 class="mb-2">{{ society.name.toUpperCase() }}</h5>
						<div>
							<div v-for="line in createDescription(society)" :key="line">
								<p v-if="line">{{ line }}</p>
								<br v-else />
							</div>
						</div>
						<div class="flex justify-between flex-wrap">
							<vs-button
								class="mt-4 mr-2 shadow-lg"
								color="primary"
								@click="displaySocietyPopup(society)"
								>Détails</vs-button
							>
							<vs-button
								:href="society.website"
								class="mt-4"
								type="border"
								color="primary"
								target="_blank"
								>Site Web</vs-button
							>
						</div>
						<div
							v-if="hasContract(society.id) && $acl.check('sadmin')"
							class="flex justify-between flex-wrap"
						>
							<vs-button
								class="mt-4 shadow-lg w-full"
								color="danger"
								@click="displayValidationDelete(society)"
								>Supprimer</vs-button
							>
						</div>
					</vx-card>
				</div>
			</div>
		</vx-card>
		<!-- NE PAS PREINSERER => GENERER DYNAMIQUEMENT -->
		<!-- <SocietyInfoPopup
      :society="selectedSociety"
      :popupActive="showSocietyPopup"
      @update:popupActive="showSocietyPopup = $event"
    />  -->
	</div>
</template>

<script>
/*
 * Pour la récupération d'image, voir transfert de fichier blob
 * const blobUtil = require('blob-util');
 */
import Vue from "vue";
import FilterCard from "@/views/filters/FilterCard";
import store from "@/store/store";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";

import "@/assets/css/toggle-switch.css";
import XLSX from "xlsx";
import VxCard from "../../components/widgets/vx-card/VxCard.vue";
import { VueTags } from "vue-tags-component";

/*
 * import Treeselect from '@riophae/vue-treeselect'
 * import '@riophae/vue-treeselect/dist/vue-treeselect.css'
 */

export default {
	name: "SocietyDashboard",
	mixins: [utilsMixin, dbFieldConvertorMixin],
	data() {
		return {
			apiErrorMsg: null,
			apiUrl: this.$store.state.backendApiUrl,
			basicImgUrl: "favicon.png",
			showSocietyPopup: false,
			showContractPopup: false,
			selectedSociety: null,
			selectedContract: null,
			commercialFilter: "",
			commercials: null,
			contactFilter: "",
			domainFilter: [],
			societyFilter: "",
			activeFilter: "",
			commercialFilterOn: false,
			contactFilterOn: false,
			societyFilterOn: false,
			activeFilterOn: false,
			displayedSocieties: [],
			displayedSocietiesLength: 0,
			societiesTag: [],
			tags: [],
			societyImageList: [],
			activityDomainOptions: [],
			contactOptions: [],
			showConfirmationPopup: false,
			delUser: "",
			delUserName: "",
			lastPage: 20,
			actionsTemplates: [
				{
					order: 1,
					emitSlugName: "new_society",
					buttonName: "Nouveau client",
					buttonIcon: "icon-plus-circle",
					buttonColor: "primary",
				},
				{
					order: 2,
					emitSlugName: "action_extract_societies",
					buttonName: "Exporter",
					buttonIcon: "icon-download-cloud",
					buttonColor: "dark",
				},
			],
			filtersTemplates: [
				{
					order: 1,
					emitSlugName: "filter_isActive",
					filterPlaceHolder: "",
					value: "",
					type: "Slider",
					params: {
						off: "Inactif",
						default: "Tous",
						on: "Actif",
					},
				},
				{
					order: 2,
					emitSlugName: "filter_society",
					filterPlaceHolder: "Client",
					value: "",
					type: "Input",
				},
				{
					order: 3,
					emitSlugName: "filter_contact",
					filterPlaceHolder: "Contact",
					value: "",
					type: "Input",
				},
				{
					order: 4,
					emitSlugName: "filter_commercial",
					filterPlaceHolder: "Commercial",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
				{
					order: 5,
					emitSlugName: "filter_tag",
					filterPlaceHolder: "Tags",
					value: "",
					type: "Tag",
					params: {
						domainFilter: [],
						activityDomainOptions: [],
					},
				},
			],

			//Tags
			tagStyle: "z-index: 10 !important;",
			showRouterPopup: true
			/*
			 * treeSelectTest: null,
			 * options: [ {
			 *     id: 'a',
			 *     label: 'a',
			 *     children: [ {
			 *       id: 'aa',
			 *       label: 'aa',
			 *     }, {
			 *       id: 'ab',
			 *       label: 'ab',
			 *     } ],
			 *   }, {
			 *     id: 'b',
			 *     label: 'b',
			 *   }, {
			 *     id: 'c',
			 *     label: 'c',
			 *   } ],
			 */
		};
	},
	components: {
		VxCard,
		ContractInfoPopup,
		FilterCard,
		VueTags,
		/*
		 * Treeselect
		 * SocietyInfoPopup
		 */
	},
	beforeCreate() {
		this.$store.dispatch("getAllSocieties");
	},
	async created() {
		this.getAllContracts();
		this.getCommercials();
		this.getAllUsers();
		this.getAllUsersSocieties();
		this.getAllSocietiesTags();

		let queries = [];
		queries.push(this.getAllActivityDomain(this.societies));
		for (let society of this.societies) {
			if (society.image) {
				queries.push(this.getSocietyImage(society));
			}
		}
		this.$http.get(this.apiUrl + "tags/all").then((res) => {
			this.tags = res.data;
		});
		this.$http.get(this.apiUrl + "tags/society/all").then((res) => {
			this.societiesTag = res.data;
		});
		// await Promise.all(queries);
	},
	mounted() {
		let societyId = sessionStorage.getItem("popupOriginSocietyId");
		// BROKEN IN PRODUCTION
		if (societyId !== null) {
			this.displaySocietyPopup(this.getSociety(societyId));
		}
		sessionStorage.removeItem("popupOriginSocietyId");
		this.createContactOptions();
	},
	watch: {
		commercialFilter: function () {
			if (this.commercialFilter == "") {
				this.commercialFilterOn = false;
			} else {
				this.commercialFilterOn = true;
			}
			this.displayedSocieties = this.filterSocieties(this.societies);
		},
		contactFilter: function () {
			if (this.contactFilter == "") {
				this.contactFilterOn = false;
			} else {
				this.contactFilterOn = true;
			}
			this.displayedSocieties = this.filterSocieties(this.societies);
		},
		domainFilter: function () {
			if (this.domainFilter == "") {
				this.domainFilterOn = false;
			} else {
				this.domainFilterOn = true;
			}
			this.displayedSocieties = this.filterSocieties(this.societies);
		},
		societyFilter: function () {
			if (this.societyFilter == "") {
				this.societyFilterOn = false;
			} else {
				this.societyFilterOn = true;
			}
			this.displayedSocieties = this.filterSocieties(this.societies);
		},
		displayedSocieties: function () {
			this.displayedSocietiesLength = this.displayedSocieties.length;
		},
		societies: async function (data) {
			this.displayedSocietiesLength = data.length;
			this.societyImageList = [];
			let queries = [];
			for (let society of data) {
				if (society.image) {
					queries.push(this.getSocietyImage(society));
				}
			}
			queries.push(this.getAllActivityDomain(data));
			if (
				this.$route.query.society_id &&
				this.displayedSocietiesLength > 0 &&
				this.showRouterPopup
			) {
				let thisSoc = this.societies.find(
					(soc) => soc.id == this.$route.query.society_id
				);
				this.showRouterPopup = false;
				this.displaySocietyPopup(thisSoc);
			}
			// await Promise.all(queries)
		},
		/*
		 * activeFilter: function() {
		 *   this.activeFilterOn = true
		 *   this.displayedSocieties = this.filterSocieties(this.societies)
		 * }
		 */
	},
	computed: {
		contracts: () => {
			return store.state.contracts;
		},
		societies: () => {
			return store.state.societies;
		},
		users: () => {
			return store.state.users;
		},
		users_societies: () => {
			return store.state.users_societies;
		},
		societies_tags: () => {
			return store.state.societies_tags;
		},
	},
	methods: {
		resetAllFilter() {
			this.commercialFilter = "";
			this.commercials = null;
			this.contactFilter = "";
			this.domainFilter = [];
			this.societyFilter = "";
			this.activeFilter = "";
			this.commercialFilterOn = false;
			this.contactFilterOn = false;
			this.societyFilterOn = false;
			this.activeFilterOn = false;
		},
		onTagAdded(tag) {
			if (this.domainFilter.indexOf(tag) < 0) this.domainFilter.push(tag);
		},

		onTagRemoved(tag) {
			this.domainFilter.splice(this.domainFilter.indexOf(tag), 1);
		},

		scroll() {
			let _this = this;
			let read = _this.$el.querySelector("#read");
			if (read.scrollTop > read.scrollHeight - read.clientHeight - 50) {
				if (this.lastPage < this.displaySocieties(this.societies).length)
					this.lastPage = this.lastPage + 20;
			}
		},
		accept() {
			this.deleteSociety(this.delUser);
			this.showConfirmationPopup = false;
		},

		decline() {
			this.delUser = "";
			this.showConfirmationPopup = false;
		},

		deleteSociety(societyId) {
			this.$http
				.delete(this.apiUrl + "usersSocieties/delete/s/" + societyId)
				.then(() => {
					this.$http
						.delete(this.apiUrl + "society/delete", { data: { id: societyId } })
						.then(() => {
							this.getAllSocieties();
							this.commercialFilter = "";
							this.domainFilter = "";
							this.contactFilter = "";
							this.societyFilter = "";
							this.$forceUpdate();
						});
				});
		},

		displayValidationDelete(society) {
			this.delUserName = society.name.toUpperCase();
			this.delUser = society.id;
			this.showConfirmationPopup = true;
		},

		/**
		 * @function displayContractInfoPopup open a new popup for selected contract
		 * @param {Object} contract - selected contract's info
		 */
		displayContractInfoPopup(contract) {
			//console.log("showContractPopup");
			this.selectedContract = contract;
			this.showContractPopup = true;
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: this.selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
					highZIndex: true,
				},
			});
			contractPopup.$mount();

			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},

		getAllContracts() {
			this.$store.dispatch("getAllContracts");
		},

		/**
		 * Fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},

		getAllSocietiesTags() {
			this.$store.dispatch("getAllSocietiesTags");
		},

		/**
		 * Fetch all the contacts
		 */
		getAllUsers() {
			this.$store.dispatch("getAllUsers");
		},

		/**
		 * Fetch all the contacts
		 */
		getAllUsersSocieties() {
			this.$store.dispatch("getAllUsersSocieties");
		},

		createContactOptions() {
			let contactList = [];
			for (let users_societies_rel of this.users_societies) {
				let userFound = this.users.find(
					(user) => user.id == users_societies_rel.users_id
				);
				if (
					userFound &&
					!contactList.find((contact) => contact.id == userFound.id)
				)
					contactList.push(userFound);
			}
			this.contactOptions = contactList;
		},

		getSocietyContact(societyId) {
			let userSocietiesRelList = this.users_societies.filter(
				(us) => us.society_id == societyId
			);
			let contactList = this.users.filter((user) =>
				userSocietiesRelList.find((us) => us.users_id == user.id)
			);
			return contactList;
		},

		/**
		 * Fetch all activity domains
		 */
		getAllActivityDomain(societies) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "tags/all")
					.then((res) => {
						let tmp = res.data;
						for (let tag of tmp) {
							tag["name"] = tag.tag_name;
							tag["slug"] = tag.tag_name;
							delete tag.tag_name;
						}
						this.activityDomainOptions = tmp;
						this.filtersTemplates[4].params.activityDomainOptions = tmp;
						resolve(tmp);
					})
					.catch((err) => {
						//console.log(err);
						reject(err);
					});
			});
		},

		/**
		 * Fetch image if society.image is true else return false
		 * @param {Society} society - The society from which image is requested
		 */
		getSocietyImage(society) {
			return new Promise((resolve, reject) => {
				if (society.image) {
					this.$http
						.get(this.apiUrl + "society/getImg/" + society.id)
						.then((image) => {
							if (image.data) {
								this.societyImageList.push({
									id: society.id,
									image: image.data,
								});
							}
							resolve(true);
							// this.testImage = image.data;
						})
						.catch((err) => {
							//console.log(err);
							reject(err);
						});
				}
			});
		},

		displaySocietyImage(societyId) {
			let foundImage = this.societyImageList.find(
				(society) => society.id == societyId
			);
			if (foundImage) return foundImage.image;
			else return this.basicImgUrl;
		},

		/**
		 * Insert Rankwell collaborators' list to this.commercials
		 */
		getCommercials() {
			this.$http
				.get(this.apiUrl + "users/all/rankwell")
				.then((fetchedRankwell) => {
					this.commercials = this.sortABC(
						fetchedRankwell.data,
						"firstname"
					).map((row) => {
						return { id: row.id, name: row.firstname + " " + row.lastname };
					});
					this.filtersTemplates[3].params.dropdownValues = this.commercials;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		displaySocietyPopup(society) {
			society["edit"] = false;
			society.image = this.displaySocietyImage(society.id);
			//Initialisation des données pour le popup
			this.selectedSociety = null; // Always reset data before assigning it
			this.selectedSociety = society;
			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});

			// @contract-info-popup="displayContractInfoPopup($event)"
			societyPopup.$mount();
			societyPopup.$on("contract-info-popup", (contract) => {
				this.displayContractInfoPopup(contract);
			});
			societyPopup.$on("refresh-client", () => {
				this.getAllSocieties();
			});
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "filter_society":
					this.societyFilter = receivedEmit[1].value;
					break;
				case "filter_contact":
					this.contactFilter = receivedEmit[1].value;
					break;
				case "filter_tag":
					this.domainFilter = receivedEmit[1].value;
					break;
				case "filter_commercial":
					this.commercialFilter = receivedEmit[1].value;
					break;
				case "filter_isActive":
					this.refreshActiveFilterValue(receivedEmit[1].value);
					break;
				default:
					break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			switch (receivedEmit[0]) {
				case "action_extract_societies":
					this.exportData(this.societies);
					break;
				case "new_society":
					// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
					this.$router.push({ name: "new_entity" });
					break;
				default:
					break;
			}
		},

		hasContract(id) {
			return (
				this.contracts.filter((contract) => contract.society_id == id).length <=
				0
			);
		},

		/**
		 * Create a description for the dashboard to fix the line number to 4 no matter how many property actually exist
		 * @param {Society} society - Society to create description for.
		 * @return {List} returnedDescription
		 */
		createDescription(society) {
			let line3;
			let country = society.country == "null" ? "" : society.country;
			let city = society.city == 0 ? "" : society.city;
			let postal_code = society.postal_code == null ? "" : society.postal_code;
			if (country || city || postal_code) {
				line3 = country + ", " + city + " " + postal_code;
			} else {
				line3 = "Adresse non-renseignée";
			}

			let fields = [
				society.adress,
				society.adress_complement,
				line3,
				society.phone,
			];

			let returnedDescription = [];
			let lineCount = 0;

			fields.forEach((element) => {
				if (element) {
					lineCount++;
					returnedDescription.push(element);
				}
			});

			while (lineCount < 4) {
				returnedDescription.push(null);
				lineCount++;
			}
			return returnedDescription;
		},

		/**
		 * Gets society from Id
		 * @param {Number} societyId - Society's ID to get name from
		 * @return {String} - Returns Society
		 */
		getSociety(societyId) {
			for (let society of this.societies) {
				if (societyId == society.id) {
					return society;
				}
			}
			return null;
		},

		refreshActiveFilterValue(value) {
			this.activeFilter = value;
			this.activeFilterOn = this.activeFilter === "" ? false : true;
			this.displayedSocieties = this.filterSocieties(this.societies);
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet() {
			if (
				this.commercialFilterOn ||
				this.contactFilterOn ||
				this.domainFilterOn ||
				this.societyFilterOn ||
				this.activeFilterOn
			)
				return true;
			return false;
		},

		/**
		 * Return list of filtered societies
		 * @param {Boolean} activeFilter - Society is active?
		 * @param {String} domainFilter - Activity Domain
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} commercialFilter - Id of the commercial in charge of the project
		 * @param {String} contactFilter - String to match in contactOptions
		 * @return {List} - Societies' list filtered
		 */
		filterSocieties(societies) {
			let societiesList = [];

			/*
			 * societyToFilter.name.toLowerCase().includes(this.societyFilter.toLowerCase())
			 * this.commercialFilter == societyToFilter.commercial_id
			 */
			let searchKeyList = {};

			this.commercialFilterOn
				? (searchKeyList["commercialFilter"] = this.commercialFilter)
				: false;
			this.contactFilterOn
				? (searchKeyList["contactFilter"] = this.contactFilter.toLowerCase())
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter.toLowerCase())
				: false;
			this.activeFilterOn
				? (searchKeyList["activeFilter"] = this.activeFilter)
				: false;

			for (let societyToFilter of societies) {
				let providerSearchKeyList = {};
				this.commercialFilterOn
					? (providerSearchKeyList["commercialFilter"] =
							societyToFilter.commercial_id)
					: false;
				this.contactFilterOn
					? (providerSearchKeyList["contactFilter"] = this.getSocietyContact(
							societyToFilter.id
					  ))
					: false;
				this.societyFilterOn
					? (providerSearchKeyList["societyFilter"] =
							societyToFilter.name.toLowerCase())
					: false;
				this.activeFilterOn
					? (providerSearchKeyList["activeFilter"] = societyToFilter.status)
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof providerSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] == "string") {
						if (typeof providerSearchKeyList[key] == "string") {
							if (!providerSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof providerSearchKeyList[key] == "object") {
							////console.log("Array")
							let checkLoop = false;
							for (let value of providerSearchKeyList[key]) {
								let service_name = "";
								service_name = value.firstname
									? service_name + value.firstname.toLowerCase()
									: service_name;
								service_name = value.lastname
									? service_name + value.lastname.toLowerCase()
									: service_name;
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else {
						if (providerSearchKeyList[key] != searchKeyList[key]) {
							check = false;
							break;
						}
					}
				}

				if (check) societiesList.push(societyToFilter);
			}

			if (this.domainFilter.length > 0) {
				let tagsIdList = [];
				for (let tag of this.domainFilter) {
					tagsIdList.push(tag.id);
				}
				societiesList = societiesList.filter(
					(society) =>
						this.societies_tags.filter(
							(st) =>
								st.society_id == society.id && tagsIdList.includes(st.tag_id)
						).length > 0
				);
			}

			//return result
			return societiesList;
		},

		/**
		 * Return list of societies to display
		 * @return {List} - societies to display
		 */
		displaySocieties(societies) {
			let societiesList = [];
			if (this.displayedSocieties.length > 0) {
				societiesList = this.displayedSocieties;
			} else {
				if (this.isFilterSet()) {
					return societiesList;
				} else {
					return societies;
				}
			}
			//return result
			return societiesList;
		},
		exportData(dataIn) {
			let data = JSON.parse(JSON.stringify(dataIn));
			for (let i = 0; i < data.length; i++) {
				let client_id = data[i]["commercial_id"];
				let tagList = this.societiesTag
					.filter((ele) => ele.society_id == data[i].id)
					.map((ele) => ele.tag_id);
				//clearing previous tag
				data[i]["activity_domain"] = "";
				data[i]["activity_domain"] = this.tags
					.filter((ele) => tagList.includes(ele.id))
					.map((ele) => ele.tag_name)
					.toString();
				for (let x = 0; x < this.users.length; x++) {
					if (this.users[x]["id"] == client_id) {
						data[i]["lastname"] = this.users[x]["lastname"];
						data[i]["firstname"] = this.users[x]["firstname"];
						break;
					}
				}
				data[i]["status"] = this.getStatus(data[i]["status"]);
				data[i]["origin"] = this.getSocietyOrigin(data[i]["origin"]);
				data[i]["is_ecommerce"] = this.getUserDashboardAccess(
					data[i]["is_ecommerce"]
				);
				data[i]["creation_timestamp"] = this.dateToFR(
					data[i]["creation_timestamp"]
				);
				data[i]["last_update_timestamp"] = this.dateToFR(
					data[i]["last_update_timestamp"]
				);

				this.$delete(data[i], "dataforseo_id");
				this.$delete(data[i], "georanker_keyword_data");
				this.$delete(data[i], "georanker_serp_Data");
				this.$delete(data[i], "image");
				this.$delete(data[i], "img_link");
				this.$delete(data[i], "robotxt_url");
				this.$delete(data[i], "sorted_keyword_position");
				this.$delete(data[i], "topkeywords");
				this.$delete(data[i], "urls_from_sitemap");
				this.$delete(data[i], "commercial_id");
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Clients";

			let header = {
				header: [
					"id",
					"activity_domain",
					"adress",
					"adress_complement",
					"analytics_id",
					"city",
					"firstname",
					"lastname",
					"country",
					"creation_timestamp",
					"gsc_url",
					"is_ecommerce",
					"last_update_timestamp",
					"name",
					"origin",
					"phone",
					"postal_code",
					"siret",
					"status",
					"tva",
					"website",
				],
				skipHeader: true,
				origin: -1,
			};

			let header_names = [
				{
					id: "Identifiant",
					activity_domain: "Domaine d'activité",
					adress: "Adresse",
					adress_complement: "Complément d'adresse",
					analytics_id: "Analytics ID",
					city: "Ville",
					country: "Pays",
					firstname: "Prénom du commercial",
					lastname: "Nom du commercial",
					creation_timestamp: "Heure de création",
					gsc_url: "Google search console url",
					is_ecommerce: "Ecommerce non/oui",
					last_update_timestamp: "Dernière heure mise à jours",
					name: "Nom",
					origin: "Origine",
					phone: "Téléphone",
					postal_code: "Code Postal",
					siret: "Siret",
					status: "État",
					tva: "TVA",
					website: "Site",
				},
			];

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Clients_export.xlsx");
		},
	},
};
</script>

<style lang="scss">
.vertical-center {
	margin: 0;
	position: absolute;
	top: 50%;
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
}
.tag {
	height: auto !important;
	background-color: rgb(180, 180, 180) !important;
}
.tags {
	height: 32px !important;
}
.tag-filter > .tags__shadow > .tags__active {
	border-radius: 5px 5px 5px 5px !important;
}
.tags__active {
	padding: 2px 0 0 2px !important;
	border-radius: 5px 5px 5px 5px !important;
	min-height: 32px !important;
}
.tags__list {
	display: grid !important;
	max-height: 300px !important;
	overflow: auto !important;
}
.tags__list-item {
	min-height: auto !important;
	margin-bottom: 1px;
	padding: 0 5px 0 5px !important;
}
.tags__list-item-tag {
	height: auto !important;
	align-self: center;
	background-color: rgb(180, 180, 180) !important;
}
.tags__search {
	border: none;
}
.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
</style>
